<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="700">
      <v-card>
        <v-card-title v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
          <span class="headline">
            Edit Staff
          </span>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="toggle"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="First name"
                  v-model="user.firstName">
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Last name"
                  v-model="user.lastName"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Email"
                  v-model="user.email">
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Phone"
                  v-model="user.phoneNumber">
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-select
                  :items="roles"
                  standard
                  label="Role"
                  v-model="user.role">
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <div v-if="disabled" class="text-center">
          Saving<br />
          <v-progress-circular
            indeterminate
            color="success"
            v-if="disabled"
          ></v-progress-circular>
        </div>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="accent" dark depressed block @click="updateUser" :disabled="disabled">Save</v-btn>
        </v-card-actions>
        <v-alert v-if="this.error != null" dismissible color="error" dark>
          <v-icon size="20" dark>warning</v-icon>{{this.error}}
        </v-alert>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    userDetails: {
      type: Object
    },
    userRole: {
      type: Object
    }
  },
  data () {
    return {
      user: {
        id: null,
        email: null,
        password: null,
        role: null,
        firstName: null,
        lastName: null,
        phoneNumber: null
      },
      disabled: false
    }
  },
  methods: {
    ...mapActions({
      update: 'user/updateUser'
    }),
    async updateUser () {
      this.disabled = true
      await this.update(this.user)
      if (!this.error) {
        this.toggle()
      }
      this.disabled = false
    }
  },
  computed: {
    ...mapGetters({
      roles: 'role/selectList',
      error: 'user/selectError'
    })
  },
  watch: {
    userDetails (details) {
      this.user.id = details.id
      this.user.email = details.email
      this.user.firstName = details.firstName
      this.user.lastName = details.lastName
      this.user.phoneNumber = details.phoneNumber
    },
    userRole (role) {
      this.user.role = role.id
    }
  }
}
</script>
<style scoped>

</style>
